import React, { ReactElement, useContext } from 'react';
import { Button } from '@wds/button';
import { T, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { generateMetricsAttribute } from '@sm/metrics';
import HeaderContext from '../../HeaderContext';

export const COPY = defineMessages({
  ADD_USERS: {
    id: 'ButtonUsers.addUsers',
    defaultMessage: 'Add users',
    description:
      '[Type: Label][Vis.: high] - This is the add users addon button on the header.',
  },
});

const ButtonUsers = (): ReactElement => {
  const { pageURL, pageURLPath } = useContext(HeaderContext);
  return (
    <Button
      size="sm"
      color="upgrade"
      href={createURL('/team/add/', {
        ut_source: 'header',
        ut_source3: 'webplat',
      })}
      data-sm-metrics={generateMetricsAttribute({
        data: {
          url: pageURL,
          pageName: pageURLPath,
          amplitudeEvent: 'header clicked cta',
          ctaName: 'add users',
        },
      })}
    >
      <T desc={COPY.ADD_USERS} />
    </Button>
  );
};

export default ButtonUsers;
